import { FormikProps, FormikValues, FormikConfig, FormikErrors, getIn } from "formik";
import { ChangeEvent } from "react";
import { handleApiError } from "../../services/baseService";

export const defaultFormikConfig: Partial<FormikConfig<any>> = {
    validateOnBlur: true,
    validateOnMount: false,
};

export interface FormikFieldProps {
    name: string;
    value: string;
    onChange: (e: ChangeEvent) => void;
    onBlur: (e: ChangeEvent) => void;
    onFocus?: (e: ChangeEvent) => void;
    error: boolean;
    helperText?: string;
}

// Used for formik form fields with validations. If the field has no validation rules, set only "name" instead.
export const formikFieldProps = (formik: FormikValues, field: string): FormikFieldProps => ({
    name: field,
    value: formik.values[field],
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    error: formik.touched[field] && Boolean(formik.errors[field]),
    helperText: formik.touched[field] && formik.errors[field],
});

export interface IFormikFieldArrayProps {
    rows: any[];
}

// FieldArray helper function for array of objects with validation
export const formikFieldArrayProps = (formik: FormikProps<IFormikFieldArrayProps>, field: string, i: number): FormikFieldProps => ({
    name: `rows.${i}.${field}`,
    value: getIn(formik?.values?.rows[i], field),
    onChange: formik.handleChange,
    onBlur: () => {
        if(formik?.isValid && formik?.touched) {
            void formik?.submitForm().catch(handleApiError);
        }
    },
    onFocus: (e) => e?.target.select(),
    error: error(formik.errors, field, i)
});

const isEmpty = (obj : FormikErrors<IFormikFieldArrayProps>) => Object.keys(obj).length === 0;
const error = (o : FormikErrors<IFormikFieldArrayProps>, k : string, i : number) =>
    !isEmpty(o) && o?.rows?.length > 0 ? typeof o.rows[i]?.[k] === "string" : false;